/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

export type ImageUploadInContentType = typeof ImageUploadInContentType[keyof typeof ImageUploadInContentType];


export const ImageUploadInContentType = {
  'image/jpeg': 'image/jpeg',
  'image/png': 'image/png',
  'image/webp': 'image/webp',
  'image/gif': 'image/gif',
  'image/avif': 'image/avif',
  'image/bmp': 'image/bmp',
  'image/heic': 'image/heic',
} as const;
